export function isSemanticallyEqual(a, b) {
  if (a === b) return true;
  if (a == null && b == null) return true;
  if (a === "" || a == null) return b === "" || b == null;
  if (b === "" || b == null) return false;
  if (
    typeof a === "object" &&
    typeof b === "object" &&
    !Array.isArray(a) &&
    !Array.isArray(b)
  ) {
    if (a.id != null && b.id != null) return a.id === b.id;
    try {
      return JSON.stringify(a) === JSON.stringify(b);
    } catch {
      return false;
    }
  }
  return String(a) === String(b);
}
